// extracted by mini-css-extract-plugin
export default {"loading-animation":"_5D3lNoNj","is-light":"_5D2IB_T1"};